import React, { useState } from "react";

const DarkMode = (props) => {
  const [enabled, setEnabled] = useState(false);
  const handleClick = () => {
    const next = !enabled;
    setEnabled(next);
    if (typeof props.toggle === "function") {
      props.toggle();
    }
  };

  React.useEffect(() => {
    const isDark = document.documentElement.classList.contains("dark");
    setEnabled(isDark);
  }, []);

  return (
    <div className="relative items-center">
      <div className="flex">
        <label
          className="inline-flex relative items-center mr-5 cursor-pointer"
          title="Change mode"
        >
          <input
            type="checkbox"
            className="sr-only peer"
            checked={enabled}
            readOnly
          />
          <div
            onClick={handleClick}
            className="w-11 h-6 bg-purple-500 rounded-full peer  peer-focus:ring-green-300  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-violet-500"
          ></div>
        </label>
      </div>
    </div>
  );
};

export default DarkMode;
